import React from 'react'
import Img from 'gatsby-image'

const Image = ({ fluid, className, alt, durationFadeIn }) => {
  return <Img className={className} fluid={fluid} alt={alt} backgroundColor='#000' fadeIn={true} durationFadeIn={durationFadeIn ? durationFadeIn : 500}/>
}

export default Image
